﻿window.cObjetHebergementAgendaCentraleRdvMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Réservation centrale"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvel réservation centrale"; }
    this.mGetLib1 = function (option) {
        return "Réservation centrale"
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-bell-concierge' style='position:relative'><i class='fas fa-hotel dx-theme-accent-as-text-color' style='position:absolute;bottom:0;right:0;font-size:60%;'></i></i>");
    }

    //retourne la liste des centrales de réservation active
    this.mGetLstDataCentraleReservationActive = function () {
        var lstIdCentrale = []
        objet.bddRef.mGetArray("hebergement_agenda_centrale").forEach(function (hebergCentrale) {
            if (!lstIdCentrale.contains(hebergCentrale.id_centrale_reservation)) lstIdCentrale.push(hebergCentrale.id_centrale_reservation)
        })
        return objet.bddRef.mGetArray("centrale_reservation").filter(function (o) {
            return lstIdCentrale.contains(o.id_centrale_reservation)
        })
    }
    //retourne la liste des hebergement pour une centrale
    //(si idcentrale == null, alors tous les hebergement avec au moins 1 centrale)
    this.mGetLstHerbergementForCentraleReservation = function (idCentrale) {
        return objet.bddRef.mGetArray("hebergement").filter(function (dataHeberg) {
            return objet.bddRef.mGetArray("hebergement_agenda_centrale").filter(function (hebergCentrale) {
                return hebergCentrale.id_hebergement == dataHeberg.id_hebergement &&
                    (!idCentrale || (idCentrale && hebergCentrale.id_centrale_reservation == idCentrale))
            }).length > 0
        })
    }

    this.mGetDatatHebergementAgendaCentrale = function () {
        return objet.bddRef.mGetArray("hebergement_agenda_centrale").filter(function (o) { return o.id_hebergement_agenda_centrale == objet.data.id_hebergement_agenda_centrale })[0]
    }

    this.mGetDatatCentraleReservation = function () {
        var idCentraleResa = this.mGetDatatHebergementAgendaCentrale().id_centrale_reservation
        return objet.bddRef.mGetArray("centrale_reservation").filter(function (o) { return o.id_centrale_reservation == idCentraleResa })[0]
    }

    this.mGetLstHebergementAgendaCentraleRdvAttente = function () {
        return objet.bddRef.mGetArray("hebergement_agenda_centrale_rdv").filter(function (o) {
            return o.ignore == "0" && (o.id_reservation_hebergement == null || o.date_deleted != null)
        })
    }

    this.mGetLstHebergementAgendaCentraleRdvFromDate = function (dat1, dat2) {
        var result = Me.objet.bddRef.mGetArray("hebergement_agenda_centrale_rdv").filter(function (resaHeberg) {
            if (dat2) {
                return (dat2 >= resaHeberg.date_debut && dat1 <= resaHeberg.date_fin)
            } else {
                return dat1 <= resaHeberg.date_fin && dat1 >= resaHeberg.date_debut
            }
        })
        return result;
    }

    this.mGetLstHebergementAgendaCentraleRdvFromDateWarning = function (dat1, dat2, idCentraleReservation) {
        var dat1 = new Date(dat1.getFullYear(), dat1.getMonth(), dat1.getDate(), 22, 0, 0)
        return this.mGetLstHebergementAgendaCentraleRdvFromDate(dat1, dat2).filter(function (resaHeberg) {
            var dataResaCentrale = objet.bddRef.mGetArray("hebergement_agenda_centrale").filter(function (o) {
                return o.id_hebergement_agenda_centrale == resaHeberg.id_hebergement_agenda_centrale
            })[0]
            if (!idCentraleReservation || idCentraleReservation == dataResaCentrale.id_centrale_reservation) {
                return resaHeberg.ignore == "0" && resaHeberg.date_deleted == null && resaHeberg.id_reservation_hebergement == null
            } else { return false }
        })
    }

    this.mGetPercentOccupeChambre = function (dat1, dat2, idCentraleReservation) {
        var dat1 = new Date(dat1.getFullYear(), dat1.getMonth(), dat1.getDate(), 22, 0, 0)
        var lstResaHeberg = this.mGetLstHebergementAgendaCentraleRdvFromDate(dat1, dat2)

        var lstHebergementId = []
        var nbOccup = 0
        nbOccup = lstResaHeberg.filter(function (resaHeberg) {
            var dataResaCentrale = objet.bddRef.mGetArray("hebergement_agenda_centrale").filter(function (o) {
                return o.id_hebergement_agenda_centrale == resaHeberg.id_hebergement_agenda_centrale
            })[0]
            return (!idCentraleReservation || idCentraleReservation == dataResaCentrale.id_centrale_reservation)
        }).length
        nbOccup += objet.bddRef.mGetArray("centrale_reservation_fermeture_hebergement").filter(function (ferme) {
            if (!idCentraleReservation || idCentraleReservation == ferme.id_centrale_reservation) {
                if (dat2) {
                    return (dat2 >= ferme.date_debut && dat1 <= ferme.date_fin)
                } else {
                    return dat1 <= ferme.date_fin && dat1 >= ferme.date_debut
                }
            } else { return false }
        }).length
        var lstIdHeberg = []
        Me.objet.bddRef.mGetArray("hebergement_agenda_centrale").forEach(function (o) {
            if (!lstIdHeberg.contains(o.id_hebergement) && (!idCentraleReservation || idCentraleReservation == o.id_centrale_reservation)) {
                lstIdHeberg.push(o.id_hebergement)
            }
        })
        var nbCh = lstIdHeberg.length
        if (dat2) {
            const timeDiff = Math.abs(dat2.getTime() - dat1.getTime());
            const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
            nbCh *= daysDiff
        }
        console.log(dat1 + "/" + nbCh)
        //return ((lstHebergementId.length == 0 || nbCh == 0) ? 0 : parseInt(lstHebergementId.length / nbCh * 100))
        var tx = ((nbOccup == 0 || nbCh == 0) ? 0 : parseInt(nbOccup / nbCh * 100))
        if (tx > 100) tx=101;
        return {
            nbOccup: nbOccup,
            nbChambre: nbCh,
            tx: tx
        }
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (!option) option = {}

        var contentMiseEnForme = contentElement
        if (contentElement.closest(".divtemplate").length > 0) {
            contentMiseEnForme = contentElement.closest(".divtemplate")
        }

        if (dataTemplate.date_deleted) {
            contentMiseEnForme.addClass("texture_import_disable")
        }

        var dataCentraleReservationHebergement = objet.bddRef.getObjet("hebergement_agenda_centrale", dataTemplate.id_hebergement_agenda_centrale).data
        var dataCentraleReservation = objet.bddRef.getObjet("centrale_reservation", dataCentraleReservationHebergement.id_centrale_reservation).data
        var dataHebergement = objet.bddRef.getObjet("hebergement", dataCentraleReservationHebergement.id_hebergement).data

        var txtIcone = "<i class='fas fa-hotel fa-shake'></i> (<b>" + dataCentraleReservation.nom + "</b>) &bull; " + mGetLibNuites(dataTemplate.date_debut, dataTemplate.date_fin) + " &bull; " + dataHebergement.nom + " &bull; "

        if (dataTemplate.id_reservation_hebergement == null) {
            if (dataTemplate.ignore == "1") {
                $("<div style='white-space:normal;'/>").appendTo(contentElement).html(txtIcone + "Ce rendez-vous est désactivé sur le planning <b>" + dataCentraleReservation.nom + "</b>. il est ignoré dans le planning de l'hébergement <b>" + dataHebergement.nom + "</b>.")
                contentMiseEnForme.css("opacity", "0.5")
                contentMiseEnForme.css("background-color", "gray")
            } else if (dataTemplate.date_deleted) {
                $("<div style='white-space:normal;font-size:120%;'/>").appendTo(contentElement).html(txtIcone + "Ce rendez-vous est supprimé sur le planning <b>" + dataCentraleReservation.nom + "</b>. il est ignoré dans le planning de l'hébergement <b>" + dataHebergement.nom + "</b>.")
                contentMiseEnForme.css("opacity", "0.5")
                contentMiseEnForme.css("background-color", "gray")
            } else {
                $("<div style='white-space:normal;'/>").appendTo(contentElement).html(txtIcone + "Cette plage horaire est réservée sur le planning <b>" + dataCentraleReservation.nom + "</b>. Elle est bloquée dans le planning de l'hébergement <b>" + dataHebergement.nom + "</b>. Vous devez relier ce rendez-vous à une reservation dans <b>" + parametre.nom + "</b> ou choisir de l'ignorer.")
                contentMiseEnForme.css("background-color", "red")
                if (option.fromScheduler) contentMiseEnForme.addClass("blink05")
            }
        } else {
            if (dataTemplate.ignore == "1") {
                $("<div style='white-space:normal;'/>").appendTo(contentElement).html(txtIcone + "Ce rendez-vous est désactivé sur le planning <b>" + dataCentraleReservation.nom + "</b>. il est ignoré dans le planning de l'hébergement <b>" + dataHebergement.nom + "</b>. Il est actuellement lié a une réservation.")
                contentMiseEnForme.css("opacity", "0.3")
                contentMiseEnForme.css("background-color", "red")
                if (option.fromScheduler) contentMiseEnForme.addClass("blink05")
            } else if (dataTemplate.date_deleted) {
                $("<div style='white-space:normal;'/>").appendTo(contentElement).html(txtIcone + "Ce rendez-vous a été supprimé du planning <b>" + dataCentraleReservation.nom + "</b>. Il est actuellement associé à une réservation présente sur votre planning <b>" + parametre.nom + "</b>.")
                contentMiseEnForme.css("opacity", "0.9")
                contentMiseEnForme.css("background-color", "red")
                contentMiseEnForme.css("color", "white")
                if (option.fromScheduler) contentMiseEnForme.addClass("blink05")
            } else if (dataTemplate.date_modified == "1") {
                $("<div style='white-space:normal;'/>").appendTo(contentElement).html(txtIcone + "Ce rendez-vous a été modifié sur le planning <b>" + dataCentraleReservation.nom + "</b>. Il est actuellement lié a une réservation dans le planning de l'hébergement <b>" + dataHebergement.nom + "</b>. Veuillez vérifier si la réservation est cohérente et confirmée.")
                contentMiseEnForme.css("background-color", "red")
                if (option.fromScheduler) contentMiseEnForme.addClass("blink05")
            } else {
                $("<div style='white-space:normal;'/>").appendTo(contentElement).html(txtIcone + "Cette plage horaire est réservée sur le planning <b>" + dataCentraleReservation.nom + "</b>. Elle est bloquée dans le planning de l'hébergement <b>" + dataHebergement.nom + "</b>. ce rendez-vous est actuellement lié a une réservation sur votre planning <b>" + parametre.nom + "</b>.")
                contentMiseEnForme.css("opacity", "0.3")
                contentMiseEnForme.css("background-color", "green")
            }
        }
        contentElement.attr("title", contentElement.html())
    }

    this.mGetLstHebergementAgendaCentraleRdv = function (dat) {
        return Me.objet.bddRef.mGetArray("hebergement_agenda_centrale_rdv").filter(function (resaHeberg) {
            return resaHeberg.ignore == "0" && resaHeberg.id_reservation_hebergement == null && (dat >= resaHeberg.date_debut && dat <= resaHeberg.date_fin)
        })
    }

    this.mShowPopup = function (optionPopup) {
        if (objet.data.id_reservation_hebergement && !objet.data.date_deleted) {
            var dataResaHeberg = objet.bddRef.getObjet("reservation_hebergement", objet.data.id_reservation_hebergement).data
            objet.bddRef.getObjet("reservation", dataResaHeberg.id_reservation).mShowPopup({ dataReservationHebergement: dataResaHeberg })
        } else {
            var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                showMaximize: false,
                title: "Centrale réservation",
                height: "auto",
                width: 500,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding-top", "0")
                    Me.itemTemplateGrille($("<div style='border-radius:10px;padding:10px;'/>").appendTo(contentElement), objet.data)

                    if (objet.data.id_reservation_hebergement && objet.data.date_deleted) {
                        $("<div style='margin-top:5px;'/>").appendTo(contentElement).text("Pour traiter la suppression de ce rendez-vous, vous devez choisir comment vous souhaitez traiter la réservation " + parametre.nom + " qui est liée à ce rendez-vous.")
                        $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                            html: "Supprimer la réservation<br/>créée dans <b>" + parametre.nom + "</b>",
                            width: "100%",
                            onClick: function (e) {
                                e.component.option("disabled", true)
                                var dataResaHeberg = objet.bddRef.getObjet("reservation_hebergement", objet.data.id_reservation_hebergement).data
                                objet.bddRef.getObjet("reservation", dataResaHeberg.id_reservation).mDelData(function (data) {
                                    objet.bddRef.getObjet(objet.data).mDelDataDefinitif()
                                })
                                pop.hide()
                            }
                        })
                        $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                            html: "Garder la réservation<br/>créée dans <b>" + parametre.nom + "</b>",
                            width: "100%",
                            onClick: function (e) {
                                e.component.option("disabled", true)
                                objet.bddRef.getObjet(objet.data).mDelDataDefinitif()
                                var dataResaHeberg = objet.bddRef.getObjet("reservation_hebergement", objet.data.id_reservation_hebergement).data
                                dataResaHeberg.id_hebergement_agenda_centrale_rdv = null
                                pop.hide()
                            }
                        })
                    } else if (objet.data.ignore == "1") {
                        $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                            text: "Réactiver le rendez-vous",
                            width: "100%",
                            onClick: function (e) {
                                e.component.option("disabled", true)
                                objet.data.ignore = "0"
                                objet.bddRef.getObjet(objet.data).mSaveChamp("ignore", function () {
                                    pop.hide()
                                    objet.bddRef.getObjet(objet.data).mShowPopup()
                                })
                            }
                        })
                    } else if (objet.data.id_reservation_hebergement == null) {
                        var dxBtDesactive = $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                            html: "Désactiver le rendez-vous <b>" + Me.mGetDatatCentraleReservation().nom + "</b><br/>dans <b>" + parametre.nom + "</b>.",
                            hint: "En désactivant le rendez-vous, celui-ci ne sera plus afficher dans votre planning et ne bloquera plus la plage horaire sur <b>" + parametre.nom + "</b>. Il restera actif sur <b>" + Me.mGetDatatCentraleReservation().nom + "</b>.",
                            width: "100%",
                            onClick: function (e) {
                                e.component.option("disabled", true)
                                objet.data.ignore = "1"
                                objet.bddRef.getObjet(objet.data).mSaveChamp("ignore")
                                pop.hide()
                            }
                        }).dxCtrlButton("instance")
                        $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                            html: "Créer une réservation<br/>du " + objet.data.date_debut.toDDMMAA() + " au " + objet.data.date_fin.toDDMMAA(),
                            hint: "",
                            width: "100%",
                            onClick: function (e) {
                                dxBtDesactive.option("disabled", true)
                                e.component.option("disabled", true)
                                $DivArrhes.slideDown(200, function () { dxMtArrhes.focus() })
                                mNotify("Saisissez les arrhes versés sur <b>" + Me.mGetDatatCentraleReservation().nom + "</b>.", "warning", 6000)
                                //var datDebut = new Date(objet.data.date_debut)
                                //datDebut.setHours(objet.bddRef.paraAppli.mGetPara("hebergement_heure_arrivee_depart").arrivee, 0, 0, 0);
                                //var datFin = new Date(objet.data.date_fin)
                                //datFin.setHours(objet.bddRef.paraAppli.mGetPara("hebergement_heure_arrivee_depart").depart, 0, 0, 0);
                                //objet.bddRef.getObjet("reservation").objetMetier.mCreateNewReservation(objet.data.id_hebergement,
                                //    1, 0, datDebut, datFin, false, objet.data.id_hebergement_agenda_centrale_rdv, function (data) {
                                //        data.dataReservationHebergement.id_hebergement_agenda_centrale_rdv = objet.data.id_hebergement_agenda_centrale_rdv
                                //        data.dataReservationHebergement.is_centrale_reservation = "1"
                                //        objet.data.id_reservation_hebergement = data.dataReservationHebergement.id_reservation_hebergement
                                //        objet.bddRef.getObjet(data.dataReservation).mShowPopup({
                                //            dataReservationHebergement: data.dataReservationHebergement
                                //        })
                                //    })
                                //pop.hide()
                            }
                        })
                        var $DivArrhes = $("<div style='padding:20px;border-left:" + theme.border + ";border-right:" + theme.border + ";border-bottom:" + theme.border + ";display:none;'/>").appendTo(contentElement)
                        var $Table = $("<table style='width:100%'/>").appendTo($DivArrhes)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:100%'>Arrhes versés sur <b>" + Me.mGetDatatCentraleReservation().nom + "</b></td>").appendTo($Tr)
                        var $Td = $("<td style='width:1px'></td>").appendTo($Tr)
                        var dxMtArrhes = $("<div class='barlow'/>").appendTo($Td).dxCtrlNumberBox({
                            width: 90,
                            labelMode: 'floating',
                            label: "Montant",
                            hint: "Montant des arrhes",
                            min: 0,
                            isFloat: false,
                            noNull: true,
                            showSpinButtons: false,
                            value: 0,
                            onValueChanged: function (e) {
                            }
                        }).dxCtrlNumberBox("instance")
                        var $Td = $("<td style='width:1px'></td>").appendTo($Tr)
                        $("<div style=''/>").appendTo($Td).dxCtrlButton({
                            text: "Créer",
                            onClick: function (e) {
                                e.component.option("disabled", true)
                                var datDebut = new Date(objet.data.date_debut)
                                datDebut.setHours(objet.bddRef.paraAppli.mGetPara("hebergement_heure_arrivee_depart").arrivee, 0, 0, 0);
                                var datFin = new Date(objet.data.date_fin)
                                datFin.setHours(objet.bddRef.paraAppli.mGetPara("hebergement_heure_arrivee_depart").depart, 0, 0, 0);
                                objet.bddRef.getObjet("reservation").objetMetier.mCreateNewReservation(objet.data.id_hebergement,
                                    1, 0, datDebut, datFin, false, objet.data.id_hebergement_agenda_centrale_rdv, false, 2, function (data) {
                                        //rajoute les arrhes
                                        if (dxMtArrhes.option("value") > 0) {
                                            try {
                                                var mtSaveArrhes = dxMtArrhes.option("value")
                                                var dataResaArrhes = objet.bddRef.getObjet("reservation_arrhes").mGetNewData()
                                                dataResaArrhes.id_reservation = data.dataReservation.id_reservation
                                                dataResaArrhes.mt = mtSaveArrhes
                                                dataResaArrhes.date_reglement = parametre.dateNow
                                                dataResaArrhes.id_mode_reglement_demande = 12
                                                dataResaArrhes.id_centrale_reservation = Me.mGetDatatHebergementAgendaCentrale().id_centrale_reservation
                                                objet.bddRef.getObjet(dataResaArrhes).mSave(function () {
                                                    objet.bddRef.getObjet("doc_cpt_mode_reglement").objetMetier.mCreateDocCptModeReg(dataResaArrhes.mt, 12, parametre.dateNow, dataResaArrhes.id_centrale_reservation, null, null, dataResaArrhes.id_reservation_arrhes, null, function () {
                                                        mFinalise()
                                                    })
                                                })
                                            } catch (e) {
                                                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                                                mFinalise()
                                            }
                                        } else { mFinalise() }

                                        function mFinalise() {
                                            data.dataReservationHebergement.id_hebergement_agenda_centrale_rdv = objet.data.id_hebergement_agenda_centrale_rdv
                                            data.dataReservationHebergement.id_centrale_reservation = Me.mGetDatatHebergementAgendaCentrale().id_centrale_reservation
                                            objet.bddRef.getObjet(data.dataReservationHebergement).mUpdateViaTrigger()
                                            objet.bddRef.getObjet(objet.data).mUpdateViaTrigger()
                                            objet.data.id_reservation_hebergement = data.dataReservationHebergement.id_reservation_hebergement

                                            objet.bddRef.getObjet(data.dataReservation).mShowPopup({
                                                dataReservationHebergement: data.dataReservationHebergement
                                            })
                                        }
                                    })
                                pop.hide()
                            }
                        })
                    }
                }
            }).dxCtrlPopupBase("instance")
            pop.show()
        }
    }

}